const PluginManager = window.PluginManager;

const toggle360 = document.querySelector('.view-360-toggle');
const fullscreen = document.querySelector('.view-fullscreen-action');

const getGallerySlider = () => {
    const gallerySliderEl = document.querySelector('[data-gallery-slider]');

    if (!gallerySliderEl) {
        return null;
    }

    try {
        return PluginManager.getPluginInstanceFromElement(gallerySliderEl, 'GallerySlider');
    } catch (error) {
        return null;
    }
};

const getSlideIndex = (event) => {
    if (Number.isInteger(event?.displayIndex)) {
        return Math.max(0, event.displayIndex - 1);
    }

    if (Number.isInteger(event?.index)) {
        return event.index;
    }

    return 0;
};

const get360SlideIndex = () => {
    const slider = document.querySelector('[data-gallery-slider]');

    if (!slider) {
        return 0;
    }

    const items = [...slider.querySelectorAll('.gallery-slider-item-container')].filter(
        (item) => !item.classList.contains('tns-slide-cloned'),
    );
    const index = items.findIndex((item) => item.querySelector('[data-360]'));

    return index >= 0 ? index : 0;
};

const getActiveGalleryIndex = () => {
    const gallerySlider = getGallerySlider();
    const sliderInfo = gallerySlider?._slider?.getInfo?.();

    if (sliderInfo && Number.isInteger(sliderInfo.displayIndex)) {
        return Math.max(0, sliderInfo.displayIndex - 1);
    }

    if (sliderInfo && Number.isInteger(sliderInfo.index)) {
        return sliderInfo.index;
    }

    const swiperActive = document.querySelector('.swiper-gallery-thumbnails .is-active');

    if (swiperActive?.parentElement) {
        return [...swiperActive.parentElement.children].indexOf(swiperActive);
    }

    const tnsActive = document.querySelector('.gallery-slider-thumbnails .tns-nav-active');

    if (tnsActive?.parentElement) {
        return [...tnsActive.parentElement.children].indexOf(tnsActive);
    }

    return 0;
};

const openZoomModal = () => {
    const zoomModal = document.querySelector('[data-zoom-modal]');

    if (!zoomModal) {
        return;
    }

    PluginManager.getPluginInstanceFromElement(zoomModal, 'ZoomModal')._openModal();
};

const open360View = () => {
    const gallerySlider = getGallerySlider();
    const targetIndex = get360SlideIndex();

    if (!gallerySlider?._slider) {
        openZoomModal();
        return;
    }

    if (getActiveGalleryIndex() === targetIndex) {
        openZoomModal();
        return;
    }

    const onChanged = (event) => {
        if (getSlideIndex(event) !== targetIndex) {
            return;
        }

        gallerySlider._slider.events.off('indexChanged', onChanged);
        openZoomModal();
    };

    gallerySlider._slider.events.on('indexChanged', onChanged);
    gallerySlider._slider.goTo(targetIndex);
};

const syncGalleryIndex = (index = getActiveGalleryIndex()) => {
    if (toggle360) {
        toggle360.hidden = index !== get360SlideIndex();
    }

    const slider = document.getElementById('tns1');

    if (slider) {
        slider.style.pointerEvents = index === get360SlideIndex() ? 'none' : 'auto';
    }

    const zoomActions = document.querySelector('.zoom-modal-actions');

    if (zoomActions) {
        zoomActions.style.opacity = index === get360SlideIndex() ? '0' : '1';
    }
};

fullscreen?.addEventListener('click', openZoomModal);
toggle360?.addEventListener('click', open360View);

const observeGalleryIndex = (target) => {
    if (!target) {
        return;
    }

    new MutationObserver(() => {
        syncGalleryIndex();
    }).observe(target, {
        attributes: true,
        childList: true,
        subtree: true,
    });
};

observeGalleryIndex(document.querySelector('.swiper-gallery-thumbnails'));
observeGalleryIndex(document.querySelector('.gallery-slider-thumbnails'));

const bindGallerySlider = (gallerySlider) => {
    gallerySlider._slider.events.on('indexChanged', (event) => {
        syncGalleryIndex(getSlideIndex(event));
    });

    gallerySlider.$emitter?.subscribe('rebuild', () => {
        gallerySlider._slider.events.on('indexChanged', (event) => {
            syncGalleryIndex(getSlideIndex(event));
        });
    });

    syncGalleryIndex();
};

const waitForGallerySlider = () => {
    const startedAt = Date.now();

    const tick = () => {
        const gallerySlider = getGallerySlider();

        if (gallerySlider?._slider?.events) {
            bindGallerySlider(gallerySlider);
            return;
        }

        if (Date.now() - startedAt < 8000) {
            window.setTimeout(tick, 100);
        }
    };

    tick();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForGallerySlider);
} else {
    waitForGallerySlider();
}
